import React from 'react';
import { Layout } from 'lucide-react';
import ServiceHeader from '../../components/services/ServiceHeader';
import ServiceFeatureCard from '../../components/ui/ServiceFeatureCard';
import { colors } from '../../styles/theme';
import ServiceSteps from '../../components/services/sections/ServiceSteps';

const features = [
  {
    iconName: "FileText",
    title: "Suite Office Complète",
    description: "Word, Excel, PowerPoint, OneNote"
  },
  {
    iconName: "Mail",
    title: "Outlook",
    description: "Email et calendrier professionnel"
  },
  {
    iconName: "Cloud",
    title: "OneDrive 1 To",
    description: "Stockage cloud sécurisé"
  },
  {
    iconName: "Users",
    title: "Microsoft Teams",
    description: "Collaboration en temps réel"
  },
  {
    iconName: "Share2",
    title: "SharePoint",
    description: "Partage de documents"
  },
  {
    iconName: "Shield",
    title: "Sécurité Avancée",
    description: "Protection des données"
  }
];

const steps = [
  {
    title: "Inscrivez-vous sur FRANCE STUDENT",
    description: "Créez votre compte étudiant en quelques clics"
  },
  {
    title: "Vérifiez votre statut étudiant",
    description: "Téléchargez votre carte étudiante ou certificat de scolarité"
  },
  {
    title: "Activez votre licence Office 365",
    description: "Recevez vos identifiants Microsoft par email sous 24h"
  }
];

const LogicielsPage = () => {
  const handleOrder = () => {
    window.location.href = 'https://my.francestudent.org/store/office-365';
  };
  return (
    <div>
      <ServiceHeader
        title="Microsoft Office 365"
        description="La suite bureautique complète de Microsoft, gratuite pour les étudiants."
        icon={<Layout className="w-8 h-8 text-white" />}
        color={colors.accent3}
        imageUrl="https://i.imgur.com/p3fzpQS.png"
      />

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        {/* Caractéristiques */}
        <div className="grid md:grid-cols-3 gap-8">
          {features.map((feature, index) => (
            <ServiceFeatureCard
              key={index}
              iconName={feature.iconName}
              title={feature.title}
              description={feature.description}
              color={colors.accent3}
            />
          ))}
        </div>

        {/* Applications incluses */}
        <section className="mt-16">
          <h2 className="text-2xl font-bold mb-8">Applications Incluses</h2>
          <div className="bg-white rounded-2xl shadow-lg p-8">
            <div className="grid md:grid-cols-2 gap-8">
              <div>
                <h3 className="font-semibold mb-4">Applications Bureau</h3>
                <ul className="space-y-3 text-gray-600">
                  <li>• Microsoft Word</li>
                  <li>• Microsoft Excel</li>
                  <li>• Microsoft PowerPoint</li>
                  <li>• Microsoft OneNote</li>
                  <li>• Microsoft Publisher</li>
                </ul>
              </div>
              <div>
                <h3 className="font-semibold mb-4">Applications Cloud</h3>
                <ul className="space-y-3 text-gray-600">
                  <li>• Microsoft Teams</li>
                  <li>• Microsoft OneDrive (1 To)</li>
                  <li>• Microsoft SharePoint</li>
                  <li>• Microsoft Stream</li>
                  <li>• Microsoft Forms</li>
                </ul>
              </div>
            </div>
          </div>
        </section>

        <div class="pt-11">
          <ServiceSteps
                title="Comment en Bénéficier"
                steps={steps}
                color={colors.accent3}
                ctaText="Commander ma suite Office 365"
                onCtaClick={handleOrder}
          />
        </div>
      </div>
    </div>
  );
};

export default LogicielsPage;